import {useCallback, useContext, useState} from "react";
import {ApiError} from "@common/exception";
import {InventoryReceiveDetail, LineItem} from "@modules/inbound/inventoryReceiveNotification/model";
import {CommonUtils} from "@modules/inbound/inventoryReceiveNotification/common";
import API from "@aws-amplify/api";
import {constructButaneApiName} from "../../../../apiConfig";
import {getAuthorizationHeader} from "@common/Auth";
import {RegionContext} from "@common/RegionContext";

const MCN = "mcn";
const BATCHID = 'batchId';
const EMPTY_STRING = '';
const INVENTORY_RECEIVE_DETAILS_KEY = "inventoryReceiveDetails";
const HYPHEN_DELIMITER = '-';

export function useGetInventoryReceiptDetails() {
  const [error, setError] = useState<ApiError | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [lineItemData, setLineItemData] = useState<LineItem[]>([]);
  const [inventoryReceiptDetailData, setInventoryReceiptDetailData] =
    useState<InventoryReceiveDetail | null>(null);
  const regionContext = useContext(RegionContext);

  const getInventoryReceiptDetail = useCallback(
    async (siteName: string, mcnBatchId: string) => {
      setIsLoading(true);
      setError(null);
      const identifiers = mcnBatchId.split(HYPHEN_DELIMITER);
      const mcn = identifiers[0];
      const batchId = identifiers[1];
      const apiUri = getApiUrl();
      try {
        const response = await API.get(
          constructButaneApiName(regionContext.region),
          apiUri, {
            response: true,
            headers: await getAuthorizationHeader()
          }
        );
        let inventoryReceiveDetails = (response?.data[INVENTORY_RECEIVE_DETAILS_KEY] ?? []) as unknown as InventoryReceiveDetail[];
        inventoryReceiveDetails.forEach(
          inventoryReceiveDetail => {
            inventoryReceiveDetail.siteName = siteName;
            inventoryReceiveDetail.createdAt = inventoryReceiveDetail.createdAt.replace("Z", " UTC");
          }
        )
        setLineItemData(inventoryReceiveDetails[0]?.lineItems ?? []);
        setInventoryReceiptDetailData(inventoryReceiveDetails[0] ?? null);
      } catch (exception) {
        const apiError = CommonUtils.getApiError(exception, siteName, 'inventory receipt detail');
        setError(apiError);
        setLineItemData([]);
        setInventoryReceiptDetailData(null);
      }
      setIsLoading(false);

      function getApiUrl() {
        const siteNameUri = `/api/receive/${siteName}/inventory-receipts?`;
        const mcnUri = `${MCN}=${mcn}`;
        const batchIdUri = `&${BATCHID}=${batchId}`;
        const getItemDetailsUri = `&itemDetails=true`;
        const apiUriComponents = [siteNameUri, mcnUri, batchIdUri, getItemDetailsUri];
        return apiUriComponents.join(EMPTY_STRING);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [regionContext]
  )

  return {
    error,
    isLoading,
    lineItems: lineItemData,
    inventoryReceiptDetail: inventoryReceiptDetailData,
    getInventoryReceiptDetail
  }

}